import React from 'react';
import { Callout, List, P, Sub, UI } from '../ui';

export const Security: React.FC = () => (
  <>
    <P>
      INA-TALK은 사내 업무용 시스템입니다. 개인 메신저와 달리 대화 내용이 회사 서버에 보관되고 회사 규정에 따라
      관리된다는 점을 알고 사용해 주세요.
    </P>

    <Sub>대화 내용은 어떻게 보관되나요</Sub>
    <List>
      <>메시지는 암호화된 상태로 서버에 저장됩니다.</>
      <>
        메시지를 삭제해도 화면에서 <UI>(삭제된 메시지입니다)</UI>로 바뀔 뿐, 기록 자체가 없어지지는 않습니다.
      </>
      <>첨부한 파일도 서버에 보관됩니다.</>
    </List>

    <Sub>대화 열람 정책</Sub>
    <List>
      <>
        법령과 사내 규정에 따라 필요한 경우에만 <b>지정된 담당자</b>가 사유를 남기고 대화 내용을 열람할 수
        있습니다. 일상적인 모니터링은 하지 않습니다.
      </>
      <>모든 열람은 감사 로그에 기록되어 최고 관리자에게 통지되며, 기록은 변조 여부가 검증됩니다.</>
      <>삭제한 메시지도 기록 대상입니다.</>
    </List>

    <Sub>이런 내용은 보내지 마세요</Sub>
    <Callout tone="danger" title="업무용 메신저 이용 수칙">
      <p>
        <b>개인정보</b> — 주민등록번호, 계좌번호, 신용카드 번호, 여권번호 등
      </p>
      <p>
        <b>기밀정보</b> — 대외비 문서, 미공개 경영정보, 고객사 비밀유지 대상 자료
      </p>
      <p>
        <b>부적절한 표현</b> — 특정인에 대한 비방·명예훼손, 욕설과 비속어, 차별적 표현
      </p>
      <p>
        <b>보안 위험 파일</b> — 출처를 알 수 없는 실행 파일이나 첨부 파일. 앱이 자동으로 차단하지만, 받은 파일이
        수상하다면 열지 말고 정보보안 담당자에게 문의하세요.
      </p>
    </Callout>

    <Sub>계열사 분리</Sub>
    <P>
      공개 채널은 소속 계열사에 해당하는 것만 보입니다. 다른 계열사 전용 채널은 목록에 나타나지 않고 내용도 볼 수
      없습니다. 다만 <b>1:1 대화와 그룹 대화는 계열사와 관계없이</b> 초대·검색이 가능합니다.
    </P>

    <Sub>기기 승인</Sub>
    <P>
      회사 보안 정책이 적용되면 <b>웹 브라우저로는 로그인할 수 없고</b>, PC 앱과 관리자가 승인한 휴대폰에서만
      INA-TALK를 쓸 수 있습니다. 비밀번호를 알아도 승인되지 않은 기기에서는 들어올 수 없습니다.
    </P>
    <List>
      <>
        <b>PC 앱</b> — 회사 네트워크에서 처음 로그인한 PC는 자동으로 등록됩니다. 회사 밖에서 처음 로그인하는 PC는
        관리자 승인을 기다립니다.
      </>
      <>
        <b>휴대폰</b> — 휴대폰에서 쓰려면 기기마다 승인을 받아야 합니다. 아이폰은 Safari가 아니라 <b>홈 화면에 추가한
        INA-TALK 앱</b>에서 로그인해 <UI>승인 요청</UI>을 누르세요. 요청하면 휴대폰 화면에 6자리 <b>확인 코드</b>가 뜹니다.
      </>
      <>
        <b>본인 확인</b> — 이미 쓰고 있는 PC 앱에서 <UI>프로필 사진</UI> → <UI>프로필 설정</UI> → <UI>내 기기</UI>를 열고
        새 휴대폰의 확인 코드를 입력하면 본인 확인이 끝납니다. PC 앱이 없다면 관리자가 연락해 올 때 코드를 알려 주세요.
        승인되면 휴대폰에서 바로 들어갈 수 있습니다.
      </>
      <>
        <b>내 요청이 아닌 요청</b> — <UI>내 기기</UI>나 알림함 <UI>보안</UI> 탭에 내가 하지 않은 승인 요청이 보이면
        <UI>내 요청이 아닙니다</UI>를 누르고 인트라넷 비밀번호를 바로 바꾸세요. 요청이 생겼다는 것은 누군가 비밀번호를 입력했다는 뜻입니다.
      </>
      <>
        <b>휴대폰을 잃어버렸을 때</b> — PC 앱의 <UI>내 기기</UI>에서 그 휴대폰을 <UI>해제</UI>하세요. 바로 로그아웃되고 알림도 멈춥니다.
        새 휴대폰은 다시 승인을 받아야 합니다.
      </>
      <>
        승인된 휴대폰은 오래(기본 90일) 쓰지 않으면 자동으로 만료됩니다. 앱을 지우거나 사이트 데이터를 지우면 새 기기로
        취급되어 다시 승인을 받아야 합니다.
      </>
    </List>

    <Sub>계정 보안</Sub>
    <List>
      <>비밀번호는 인트라넷 계정과 동일합니다. 인트라넷에서 비밀번호를 바꾸면 이 앱에서도 바뀐 비밀번호를 쓰세요.</>
      <>공용 PC에서는 사용 후 반드시 로그아웃하세요.</>
      <>
        관리자가 권한을 변경하면 <UI>권한이 변경되었습니다. 다시 로그인하면 적용됩니다.</UI> 안내가 표시됩니다.
      </>
      <>
        PC에서는 일정 시간이 지나면 자동으로 로그아웃되며 <UI>세션이 만료되었습니다.</UI> 안내와 함께 로그인
        화면으로 돌아갑니다(PC 앱에서 <UI>자동 로그인</UI>을 켜 두었다면 저장된 정보로 조용히 다시 로그인됩니다).
        휴대폰·태블릿에서는 앱을 이따금 열기만 하면 로그인이 유지됩니다(기기 승인 정책이 적용되면 승인된 휴대폰은
        30일 안에 한 번 열면 유지됩니다).
      </>
    </List>
  </>
);
